import NewIcon from '@assets/images/newIcon.svg';
import InProgressIcon from '@assets/images/inProgress.svg';
import CallStartedIcon from '@assets/images/callStarted.svg';
import CallCompletedIcon from '@assets/images/callCompleted.svg';
import CompletedIcon from '@assets/images/completed.svg';
import CancelledIcon from '@assets/images/cancelled.svg';
import OnHoldIcon from '@assets/images/OnHoldIcon.svg';

export enum CallStatusEnum {
  New = 'new',
  InProgress = 'in progress',
  CallStarted = 'call started',
  CallCompleted = 'call completed',
  Completed = 'completed',
  Abandoned = 'abandoned',
  Cancelled = 'canceled',
  OnHold = 'on hold',
}

export const getChipDetails = (status: CallStatusEnum) => {
  switch (status) {
    case CallStatusEnum.New:
      return { color: 'bg-New', icon: <NewIcon /> };
    case CallStatusEnum.InProgress:
      return { color: 'bg-InProgress', icon: <InProgressIcon /> };
    case CallStatusEnum.CallStarted:
      return { color: 'bg-CallStarted', icon: <CallStartedIcon /> };
    case CallStatusEnum.CallCompleted:
      return { color: 'bg-CallCompleted', icon: <CallCompletedIcon /> };
    case CallStatusEnum.Completed:
      return { color: 'bg-Completed', icon: <CompletedIcon /> };
    case CallStatusEnum.Cancelled:
      return { color: 'bg-Cancelled', icon: <CancelledIcon /> };
    case CallStatusEnum.OnHold:
      return { color: 'bg-Onhold', icon: <OnHoldIcon /> };
    default:
      return { color: 'default', icon: <NewIcon /> };
  }
};

export const callStatusToString: { [key in CallStatusEnum]: string } = {
  [CallStatusEnum.New]: 'New',
  [CallStatusEnum.InProgress]: 'In Progress',
  [CallStatusEnum.CallStarted]: 'Call Started',
  [CallStatusEnum.CallCompleted]: 'Call Completed',
  [CallStatusEnum.Completed]: 'Completed',
  [CallStatusEnum.Cancelled]: 'Cancelled',
  [CallStatusEnum.Abandoned]: 'Abandoned',
  [CallStatusEnum.OnHold]: 'On Hold',
};
